
export const setDevices = (state, devices) => {
    state.devices = devices;
}

export const setApps = (state, apps) => {
    state.apps = apps;
}

export const setLogs = (state, logsList) => {
    state.logs = logsList;
}

export const setTerminalOutput = (state, terminalOutput) => {
    state.terminalOutput.push(terminalOutput);
}



// WEBPACK FOOTER //
// ./src/store/mutations.js